import {
    SUCCESSION_DRAWER_OPEN,
    SUCCESSION_DRAWER_CLOSE,
    SUCCESSION_PROFILE_DRAWER_UPDATE
} from '../constants/successionDrawerConstants';

const initialState = {
    userName: null,
    profileData: {}
};

const successionDrawerReducer = (state = initialState, action) => {
    switch (action.type) {
        case SUCCESSION_DRAWER_OPEN:
            return {
                ...state,
                userName: action.userName
            };
        case SUCCESSION_DRAWER_CLOSE:
            return initialState;
        case SUCCESSION_PROFILE_DRAWER_UPDATE:
            return {
                ...state,
                profileData: action.selectedProfileDrawer
            };
        default:
            return state;
    }
};

export default successionDrawerReducer;